import React from "react";
import { Container } from "./style";
import GoogleMap from "../../components/Maps/YandexMap";

export default () => (
    <Container>
        <GoogleMap />
    </Container>
);
